export default "__VITE_ASSET__c9fa24d3__"